import {
  ERROR_SHOW,
  ERROR_HIDE
} from './types'

const initialState = {
  isDisplayed: false,
  title: '',
  message: ''
}

const getters = {
  isDisplayed: state => state.isDisplayed
}

const mutations = {
  [ERROR_SHOW] (state, message) {
    state.isDisplayed = true
    if ('title' in message) {
      state.title = message.title
    } else {
      state.title = "Une erreur s'est produite"
    }

    if ('content' in message) {
      state.message = message.content
    } else {
      state.message = 'Une erreur est survenue. Nous avons été alertés par courriel afin que cette dernière soit corrigée dans les meilleurs délais. Merci pour votre patience.'
    }
  },
  [ERROR_HIDE] (state) {
    state.isDisplayed = false
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/errors.js